import { commonProposalFormApplicationMapper } from "./commonProposalFormMapper";
import * as lookup from "../../../../../static/lookup.json"
import { getAge } from "../../helperFunctions"
import {valueParser, fullNameCoverter, policyTermValue, repeatableJsonArrayMapper} from "../../dataLayerMapper"

export function stringPath(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  // console.log(a, "a")
  for (var i = 0, n = a.length; i < n; ++i) {

    var k = a[i];
    // console.log(k, "k")
    if (k in o) {
      // console.log("inside if main")
      o = o[k];
      // console.log("inner o", o)
      if (!o) {
        // console.log("inside inner if")
        return ""
      }
    } else {
      // console.log("inside else")
      return "";
    }
  }
  return o;
}

export function fundValueJson(payload) {
  let fund = []
  let nVestFundValue = []
  let fundJson = lookup['promise4GrowthfundValue']['fundMapping']

  if (!fundJson)
    return fund
    Object.keys(fundJson).forEach(path => {
    if (stringPath(payload, path)) {

      let fundName
      let value
      let allocationPercentage
      fundName = stringPath(payload, path)
      if (fundName) {
        value = fundJson[path].fundName
        allocationPercentage = stringPath(payload, fundJson[path].allocationPath)
        let obj = {
          "fundName": value,
          "allocationPercent": allocationPercentage
        }
        let obj1 = {
          "fundId": value,
          "fundPercent": allocationPercentage
        }
        fund.push(obj)
        nVestFundValue.push(obj1)
      }
    }
    else {
      let value
      let allocationPercentage
      value = fundJson[path].fundName
      allocationPercentage = parseInt("0")
      let obj1 = {
        "fundId": value,
        "fundPercent": allocationPercentage
      }
      nVestFundValue.push(obj1)
    }

  })
  let fundValue = [
    fund,
    nVestFundValue
  ]
  return fundValue
}

export function p4gPlusMapper(payload, journeyId, pageId, sectionId,applicationJSON2 ){
    let pageIndicator = pageId + "." + sectionId 
    if (pageId === "Promise4GrowthPlusViewBenefitIllustrationPage" && payload?.hasOwnProperty("Promise4GrowthPlusViewBenefitIllustrationPage")){
      const benefitPageObject = payload["Promise4GrowthPlusViewBenefitIllustrationPage"]
      if (benefitPageObject?.hasOwnProperty("Promise4GrowthPlusCFpersonelDetailsSection") 
        || benefitPageObject?.hasOwnProperty("SectionCommonResidenceAndOccupation")){
        payload["Promise4GrowthPlusCalculateFundValuePage"] = {
          ...payload["Promise4GrowthPlusViewBenefitIllustrationPage"]
        }
      }
    }
    let laAndProposerSame =  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAslifetobeAssuredandProposer")
    let emailID
    let mobileNo
    let countryCode
    let proposerfirstName =''
    let proposermiddleName =''
    let proposerlastName =''
    if(laAndProposerSame === "N"){
        emailID = valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerEmail")?.toUpperCase()
        mobileNo = valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAnumber")
        countryCode =  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerCode")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).firstName 
        proposermiddleName = fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).lastName || '.'
    }
    else {
        emailID = valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "email")?.toUpperCase()
        mobileNo = valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "contactNo")
        countryCode =  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "mobileNumber")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).firstName
        proposermiddleName = fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).lastName || '.'
    }
    applicationJSON2['lifeAssuredDetails'] = {
        ...applicationJSON2['lifeAssuredDetails'],
        "fullName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).fullName,
        "firstName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).firstName,
        "middleName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).middleName,
        "lastName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CPPersonalDetailName")).lastName || '.',
        "gender": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "gender"),
        "dob": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "dateOfBirth"),
        "emailId": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "email"),
        "isLaAndPropSame": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "CFislifetobeAssuredandProposer"),
        "proofOfIdentity": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "ageIdentityProof") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "ageIdentityProof"),
        "maritalStatus"  : valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "martialStatus"),
        "countryOfBirth": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryofbirth") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth"),
        "citizenship": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship"),
        "nationality": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "nationality"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "contactNo"),
                "countryCode":lookup.phoneCountryCodeDupeMapper[0][valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "mobileNumber")],
                "countryCodeMap": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "mobileNumber"),
                "emailId": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "email")?.toUpperCase(),
            },
            "currentAddress": {
                "country": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAcountry") ? valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAcountry") :lookup.countryCodeToCountry[0][valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "mobileNumber")],
                "state": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAstate"),
                "pinCode": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPApincode"),
                "cityMap": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GopaCity"),
                "cityDistrict": payload.Promise4GrowthPlusCalculateFundValuePage?.Promise4GrowthPlusCFpersonelDetailsSection?.GopaCity !== "OTHERS" ? valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GopaCity") :  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "citytextgsp"),
            }
        },
        "employmentDetails": {
            "annualIncome": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "annualIncome"),
            "education": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "educationalQualification"),
            "occupation": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAyouAre"),
            "natureOfOccupation": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAexactNatureOfOccupation"),
            "employerIndustry": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAnatureOfIndustry") ,
            "staff": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "FlexiCPemployeeOfCanaraHSBC"),
            "staffId": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPemployeeID"),
            "employerName": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPcompanyName"),
            "otherEmployerName": lookup.groupComapny[0][valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPcompanyName")] || ''
        },
    }

    applicationJSON2['proposerDetails'] = {
        ...applicationJSON2['proposerDetails'],
        // "proposerDetails.payorSameAsLA":  valueParser(payload, "PageGuaranteedSavingsCalculatePremium", "SectionGuaranteedSavingsPersonelDetails", "islifetobeAssuredandProposer"),
        "fullName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).fullName,
        "firstName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).firstName,
        "middleName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).middleName,
        "lastName": fullNameCoverter(valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAProposername")).lastName || '.',
        "proposerDetails.dob": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerDateOfBirth"),
        "proposerDetails.gender": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerGender"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAnumber"),
                "countryCode": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerCode"),
                "emailId": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerEmail")?.toUpperCase()
            }
        },

        "employmentDetails": {
            "annualIncome":valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerAnnualIncome"),
            "education": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GOPAproposerEducationalQualification"),
        },

    }

    applicationJSON2["productDetails"] = {
        ...applicationJSON2["productDetails"],
        "consentPrivacyWaived": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "privacyPolicy") || false,
        "gstWaiverInd": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "GIAPNreAccount") || "N",
        "policyTerm": policyTermValue(payload?.Promise4GrowthPlusCalculateFundValuePage?.Promise4GrowthPlusInvestmentDetailsSection?.alphaPT, payload?.Promise4GrowthPlusCalculateFundValuePage?.Promise4GrowthPlusCFpersonelDetailsSection?.dateOfBirth),
        "ptValue": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaPT"),
        "premiumPaymentTerm": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaPPT"),
        "modeOfPayment": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaPaymentFrequency"),
        "premiumFrequency": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaPaymentFrequency"),
        "planOption":  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaInvestmentPlanOption"),
        "planCoverage":  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaInvestmentPlanOption") ,
        "planName":  valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaInvestmentPlanOption"),
        "installmentPremium": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaInstallmentPremium"),
        "modalPrem": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusInvestmentDetailsSection", "alphaInstallmentPremium"),
        // "sumAssured" : valueParser(payload,"Promise4GrowthPlusCalculateFundValuePage","Promise4GrowthPlusInvestmentDetailsSection","alphaSumAssured"),
        "sso" : valueParser(payload,"Promise4GrowthPlusCalculateFundValuePage","Promise4GrowthPlusPortfolioManangementSection","optionForSSO"),
        "funds" : fundValueJson(payload)
    }

    applicationJSON2["basicDetails"] = {
        ...applicationJSON2["basicDetails"],
        "referrerName": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "referrerNameGIAP"),
        "referrerId": valueParser(payload, "Promise4GrowthPlusCalculateFundValuePage", "Promise4GrowthPlusCFpersonelDetailsSection", "referrerIdGIAP"),  
        "emailID" : emailID,
        "mobileNo": mobileNo,
        "countryCode": countryCode 
    }

    applicationJSON2["journeyDetailsDirectKeys"] = {
        ...applicationJSON2["journeyDetailsDirectKeys"],
        "bankDetails": {
            "receivingRefundOrPayments": {
                "firstName":proposerfirstName,
                "middleName":proposermiddleName,
                "lastName":proposerlastName
            }
        }
    }
            
    
    if(pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalInsuranceHistory" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalHealth&LifestyleDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillproposalOccupationDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalMedicalInformation" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNomineeDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.FlexiEdgeFillProposalAppointeeSection" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCovidQuestionnaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeBankDetailsOfProposer" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionOil" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMarine" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMining" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionDefence" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFemaleMedicalQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.reviewDetailsflexiEdge" || 
    pageIndicator === "makePayment.make-Payment" ||
    pageIndicator === "makePayment.successful-transaction" ||
    pageIndicator === "makePayment.unsuccessful-transaction" ||
    pageIndicator === "makePayment.pending-transaction" ||
    pageIndicator === "makePayment.eNach-physicalMandate" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.declaration" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.UploadDocuments" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.application-submission" 
    ){
        applicationJSON2  = commonProposalFormApplicationMapper(payload, journeyId, pageId, sectionId, applicationJSON2)
    }
    return applicationJSON2
}
